module.exports = __webpack_public_path__ + "media/images/icons/icons_small/47_shoppingBag-475286c71411548c77ef3a653fdc6cad.png";